import { useState } from 'react';
import { IconArrowRight, IconDown, IconUp } from '@ui/src';
import { StatusTitle } from '../../hoc/cash-collection/types';
import { StatusItemTypes } from './types';

import cn from './styles.module.css';

const StatusItem = ({
  item,
  updateStatusIsLoading,
  onUpdate,
  isFetching,
}: StatusItemTypes) => {
  const [collapsed, setCollapsed] = useState(false);

  let buttonText = 'Next status';
  let buttonIcon = <IconArrowRight />;

  if (!item.allowed) {
    buttonText = 'Conditions are not met';

    buttonIcon = collapsed ? (
      <IconUp className={cn.arrowIcon} />
    ) : (
      <IconDown className={cn.arrowIcon} />
    );
  }

  return (
    <div className={cn.statusItemWrapper}>
      <button
        type="button"
        className={`${cn.statusChangeWrapper} ${
          updateStatusIsLoading || isFetching ? cn.statusButtonDisabled : ''
        }`}
        onClick={() =>
          item.allowed ? onUpdate(item.statusNext) : setCollapsed(!collapsed)
        }
        key={item.statusNext}
        disabled={updateStatusIsLoading || isFetching}
      >
        <div className={cn.statusChangeValue}>
          {/* @ts-ignore */}
          {StatusTitle[item.statusNext as StatusTitle]}
          {!item.errors && item?.warnings && item?.warnings?.length > 0 && (
            <ul className={cn.warningsWrapper}>
              {item?.warnings?.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          )}
        </div>
        <div
          className={`${cn.changeStatusButton} ${
            !item.allowed ? cn.redText : ''
          }`}
        >
          {updateStatusIsLoading ? (
            'Loading...'
          ) : (
            <>
              {buttonText}
              {buttonIcon}
            </>
          )}
        </div>
      </button>
      {collapsed && (
        <>
          <ul className={cn.errorsList}>
            {item?.errors?.map((error, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`${error}-${index}`}>{error}</li>
            ))}
          </ul>
          {item?.warnings && item?.warnings?.length > 0 && (
            <ul className={`${cn.warningsWrapper} ${cn.errorsWranings}`}>
              {item?.warnings?.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default StatusItem;
